import React from 'react'
import { connect } from 'react-redux'
import { GET_LIST, showNotification } from 'react-admin'
import { Typography, CircularProgress, Button, Grid, Collapse } from '@material-ui/core'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { arrayMove, List as MovableList } from 'react-movable'
import MovableItem from '../../movableItem'
import dataProvider from '../../../../../providers'
import { getResource } from '../../../../../config/resources'
import { PATCH } from '../../../../../providers/dataProvider/types'

class CompetitionsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openList: false,
      competitions: [],
      loading: false,
      fetching: false,
    }
  }

  componentDidMount() {
    this.getCompetitions()
  }

  getCompetitions = () => {
    this.setState({ loading: true })
    dataProvider(GET_LIST, getResource('competiciones', 'competitions'), {
      sort: {
        field: 'positionApp',
        order: 'ASC',
      },
      filter: {
        showInApp: true,
      },
      pagination: { page: 1, perPage: 100 },
    }).then((res) => this.setState({ competitions: res.data, loading: false }))
  }

  handleChangeOrder = ({ oldIndex, newIndex }) => {
    let newContent = [...this.state.competitions]
    newContent = arrayMove(newContent, oldIndex, newIndex)
    newContent = newContent.map((item, index) => ({
      ...item,
      positionApp: index,
    }))
    this.setState({ competitions: newContent })
  }

  handleSaveData = () => {
    this.setState({ fetching: true })
    Promise.all(
      this.state.competitions.map((competition) => {
        return dataProvider(PATCH, getResource('competiciones', 'competitions'), {
          id: competition.id,
          data: {
            positionApp: competition.positionApp,
          },
        })
      })
    )
      .then(({ data }) => {
        this.setState({ fetching: false })
        this.props.showNotification('Competitions order updated', 'success')
      })
      .catch((error) => {
        this.setState({ error: true, fetching: false })
        this.props.showNotification(error.message, 'error')
      })
  }

  handleClick = () => {
    this.setState({
      openList: !this.state.openList,
    })
  }

  render() {
    return (
      <>
        <div style={{ margin: '29px' }}>
          {this.state.loading ? (
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography component="h2" variant="h2" style={{ marginBottom: '16px', marginRight: '16px' }}>
                Loading competitions
              </Typography>
              <CircularProgress size={24} />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'flex-start' }} onClick={() => this.handleClick()}>
              <Typography component="h2" variant="h2" style={{ marginBottom: '16px' }}>
                Competitions
              </Typography>
              <div style={{ marginLeft: '16px' }}>{this.state.openList ? <ExpandLess /> : <ExpandMore />}</div>
            </div>
          )}

          {this.state.competitions && this.state.openList && (
            <Collapse in={this.state.openList} timeout={600}>
              <Grid item xs={12} lg={8}>
                <div style={{ opacity: this.state.loading ? 0 : 1, transition: 'opacity 350ms' }}>
                  <MovableList
                    lockVertically
                    values={this.state.competitions}
                    onChange={this.handleChangeOrder}
                    renderList={({ children, props }) => <div {...props}>{children}</div>}
                    renderItem={({ index, props, isDragged, value }) => {
                      return (
                        <div {...props} key={value.id || index} index={index} style={{ ...props.style, zIndex: 1 }}>
                          <MovableItem isDragged={isDragged} item={value} />
                        </div>
                      )
                    }}
                  />
                  <Grid item justify="flex-end">
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      disabled={this.state.loading || this.state.fetching}
                      onClick={() => this.handleSaveData()}
                    >
                      {this.state.fetching ? 'Saving...' : 'Save'}
                    </Button>
                  </Grid>
                </div>
              </Grid>
            </Collapse>
          )}
        </div>
      </>
    )
  }
}

const enhance = connect(null, {
  showNotification,
})

export default enhance(CompetitionsList)
